import { fetch, base } from './index';

/**
 * 登出
 * @param query
 */
export function logoutServ(query) {
    return fetch({
        url: `${base}/logout`,
        data: query,
        method: 'POST'
    });
}

/**
 * 登录
 * @param query
 */
export function loginServ(query) {
    return fetch({
        url: `${base}/login`,
        data: query,
        method: 'POST',
        passErr: true
    });
}

/**
 * 发送登录验证码
 * @param query
 * @returns {*}
 */
export function sendLoginSmsServ(query) {
    return fetch({
        url: `${base}/login/sendSms`,
        data: query,
        method: 'POST',
        passErr: true
    });
}

/**
 * 注册
 * @param query
 */
export function registerServ(query) {
    return fetch({
        url: `${base}/register`,
        data: query,
        method: 'POST',
        passErr: true
    });
}

/**
 * 发送注册验证码
 * @param query
 * @returns {*}
 */
export function sendRegisterSmsServ(query) {
    return fetch({
        url: `${base}/register/sendSms`,
        data: query,
        method: 'POST',
        passErr: true
    });
}
